module.exports = __webpack_public_path__ + "static/media/MattScheurer.88c981e0.jpeg";